// src/pages/help/helpTopics.js
// Registre des guides du centre d'aide. Une entrée = une page dédiée
// (/help/<slug>), pas une simple ancre. Chaque page fonctionnalité peut donc
// pointer un bouton « Comment ça marche ? » vers son guide via helpRoute().
import {
  HelpCircle,
  Bot,
  MessageSquare,
  NotebookText,
  Send,
  Repeat2,
  Trophy,
  Target,
  BarChart3,
  LineChart,
  CreditCard,
  LayoutGrid,
} from "lucide-react";

// L'ordre du tableau = l'ordre d'affichage dans la grille du centre d'aide.
export const HELP_TOPICS = [
  { slug: "faq-generale", icon: HelpCircle, accent: "violet", to: null },
  { slug: "agent-ia-mt5", icon: Bot, accent: "indigo", to: "/agent" },
  { slug: "chat-ia", icon: MessageSquare, accent: "fuchsia", to: "/" },
  { slug: "journal-auto", icon: NotebookText, accent: "sky", to: "/journal-auto" },
  { slug: "execution", icon: Send, accent: "emerald", to: "/execution" },
  { slug: "copy-trading", icon: Repeat2, accent: "teal", to: "/copy-trading" },
  { slug: "challenges", icon: Trophy, accent: "amber", to: "/challenge" },
  { slug: "strategy-hub", icon: Target, accent: "violet", to: "/strategies" },
  { slug: "analyse-fondamentale", icon: BarChart3, accent: "indigo", to: "/market-analysis" },
  { slug: "graphiques-backtest", icon: LineChart, accent: "sky", to: "/backtest" },
  { slug: "autres", icon: LayoutGrid, accent: "violet", to: null },
  { slug: "abonnement-paiements", icon: CreditCard, accent: "rose", to: null },
];

const BY_SLUG = HELP_TOPICS.reduce((acc, topic) => {
  acc[topic.slug] = topic;
  return acc;
}, {});

export function getHelpTopic(slug) {
  return BY_SLUG[String(slug || "")] || null;
}

// Route du guide. Import direct dans les pages fonctionnalités :
//   <Link to={helpRoute("execution")}>Comment ça marche ?</Link>
export function helpRoute(slug) {
  return slug ? `/help/${slug}` : "/help";
}

// Teintes des cartes du hub (light + dark).
export const ACCENTS = {
  violet: "bg-violet-500/12 text-violet-700 dark:text-violet-300",
  indigo: "bg-indigo-500/12 text-indigo-700 dark:text-indigo-300",
  fuchsia: "bg-fuchsia-500/12 text-fuchsia-700 dark:text-fuchsia-300",
  sky: "bg-sky-500/12 text-sky-700 dark:text-sky-300",
  emerald: "bg-emerald-500/12 text-emerald-700 dark:text-emerald-300",
  teal: "bg-teal-500/12 text-teal-700 dark:text-teal-300",
  amber: "bg-amber-500/14 text-amber-700 dark:text-amber-300",
  rose: "bg-rose-500/12 text-rose-700 dark:text-rose-300",
};
